import React from 'react';

import ActionButton, {
  ActionLink,
  IActionButtonProps,
  IActionLinkProps,
} from 'components/action-button';
import { withTypography } from 'components/ui';
import { spacing } from 'styles/constants';

type StyledActionButtonProps = Omit<IActionButtonProps, 'children'> & {
  children?: React.ReactNode;
};

type StyledActionLinkProps = Omit<IActionLinkProps, 'children'> & {
  children?: React.ReactNode;
};

export const LoadingText = withTypography({
  textAlign: 'center',
  fontSize: 'md',
  lineHeight: 'md',
  fontFamily: 'body',
  style: {
    paddingVertical: spacing.$2,
  },
});

export const StyledActionButton = ({ _text, ...props }: StyledActionButtonProps) =>
  React.createElement(ActionButton, {
    _text: { fontFamily: 'alternative', ..._text },
    ...props,
  });

export const StyledActionLink = ({ _text, ...props }: StyledActionLinkProps) =>
  React.createElement(ActionLink, {
    _text: { fontFamily: 'alternative', ..._text },
    ...props,
  });
